import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/rootReducer';

export const selectMenu = (state: RootState) => state.menu;

export const selectSettingsGroups = createSelector(selectMenu, (menu) => menu.settingsGroups);
export const selectServicesGroups = createSelector(selectMenu, (menu) => menu.servicesGroups);
